import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'
import type {
    CouponInsert,
    ForcedInterstitial,
    HomeData,
    MarketingAnimationShortDTO
} from 'shared/types'

export type RootState = {
    homePage: ?HomeData,
    interstitialAnimation: ?MarketingAnimationShortDTO,
    forcedInterstitial: ?ForcedInterstitial,
    couponInsert: CouponInsert,
    dataLoaded?: boolean,
    error?: any,
    networkError?: any
}

const initialRootState = {
    homePage: null,
    interstitialAnimation: null,
    forcedInterstitial: null,
    couponInsert: {},
    dataLoaded: false
}

export const reducer = (
    state: RootState = initialRootState,
    action: Action
): RootState => {
    switch (action.type) {
        case 'PAGE_DATA_ROOT_RESPONSE':
            const { analyticsData, ...data } = action.data
            return {
                ...state,
                ...data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'PAGE_DATA_ROOT_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.app.init)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
